module.exports = __webpack_public_path__ + "img/store-amazon.8ba21bc1.svg";